import { AxiosError } from 'axios';
import { IReduxAction } from 'constants/types/IReduxAction';
import { ProgramEnum } from 'constants/types/Program';
import { ProgramWithDays } from 'view-models/ProgramViewModel';

export interface ProgramState {
  error?: AxiosError | Error;
  Programs?: ProgramWithDays[];
}

const initialState: ProgramState = {};

export default (
  state = initialState,
  { type, payload, error }: IReduxAction,
): ProgramState => {
  switch (type) {
    case ProgramEnum.FETCH_ALL_PROGRAM_SUCCESS:
      return { ...state, Programs: payload };
    case ProgramEnum.FETCH_ALL_PROGRAM_FAILURE:
      return { ...state, error };
    default:
      return state;
  }
};
